import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import ls from 'helpers/localStorage';
import reducer from '../reducers/reducer';

const sagaMiddleware = createSagaMiddleware();
// const persistedState = ls.loadState();
const persistedState = {};

export default function configureStore() {
  const middleware = applyMiddleware(thunk, sagaMiddleware);
  const enhancer =
    process.env.NODE_ENV === 'development'
      ? composeWithDevTools(middleware)
      : middleware;

  return createStore(reducer, persistedState, enhancer);
}
